var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopsMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5768 0C9.21254 0 0 9.21253 0 20.5768C0 27.1624 3.09379 33.0254 7.90726 36.7917C7.97679 36.8461 8.03933 36.909 8.09268 36.9794L20.2032 52.9493C20.6034 53.4769 21.3966 53.477 21.7968 52.9493L33.9073 36.9793C33.9607 36.909 34.0232 36.8461 34.0928 36.7917C38.9062 33.0254 42 27.1624 42 20.5768C42 9.21253 32.7875 0 21.4232 0H20.5768Z",
    fill: "#C71F1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.20001,
    y: 4.1543,
    width: 33.6,
    height: 33.2308,
    rx: 16.6154,
    fill: "#DF7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsMarker);
export default __webpack_public_path__ + "static/media/stopsMarker.365dce32fe64fe6ef9f77a2a6a178fe2.svg";
export { ForwardRef as ReactComponent };